import { put, select } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import { keysToCamelCase } from "lib/helpers";
import actions from "rdx/actions";
import selectors from "rdx/selectors";
import { isEmpty } from "lodash";
import messages from "../messages";

function* deleteUpdateEmail(action) {
  const { userId } = action.payload;
  const { success, data, error } = yield* makeRequest.delete("/profile/email", { user_id: userId });

  if (success && data) {
    const newProfile = yield select(selectors.getProfile);
    if (!isEmpty(newProfile)) {
      delete newProfile.emailChangeRequest;
      yield put(actions.setProfile(keysToCamelCase(newProfile)));
    } else {
      const newUserDetail = yield select(selectors.getUserDetails);
      delete newUserDetail.emailChangeRequest;
      yield put(actions.setUserDetails(keysToCamelCase(newUserDetail)));
    }

    yield put(
      actions.newSuccessEvent({
        message: messages.DELETE_EMAIL_UPDATE_SUCCESS,
      }),
    );
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_DELETING_EMAIL_UPDATE,
    });
  }
  return null;
}

export default deleteUpdateEmail;
